@import "../user-prompts";

.alert-modal {
  .modal-backdrop {
    .modal-dialog {
      width: 500px;
      .modal-content {
        .modal-header {
          .modal-title {
          }
        }
        .modal-body {
          .text{
            padding:18%;

          }
        }
        .modal-footer {
          .btn-close {
            @include footerButton(#900035);
          }
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/user-prompts/alert-modal/alert-modal.scss